<app-overlay-loader *ngIf="loader"></app-overlay-loader>
<!-- Header Section -->
<div class="page-header">
  <h1>Manage Self Assessments</h1>
</div>

<!-- Self Assessments Grid -->
<div class="assessments-grid">
  <div *ngFor="let assessment of selfAssessments" class="assessment-card">
    <div class="card-header">
      <h3 class="assessment-name">{{assessment.name}}</h3>
      <div class="action-buttons">
        <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text" (click)="editAssessment(assessment)"></button>
        <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text" style="color: red;" (click)="deleteAssessment(assessment)"></button>
      </div>
    </div>

    <div class="card-content">
      <div class="info-section">
        <div class="info-item">
          <label>Quiz IDs</label>
          <div class="quiz-ids">{{assessment.quiz_ids ? assessment.quiz_ids : 'No quizzes assigned'}}</div>
        </div>

        <div class="info-item">
          <label>Score Formula</label>
          <div class="formula-container">
            <div class="formula-display">{{assessment.formula ? assessment.formula : 'No formula set'}}</div>
          </div>
        </div>

        <div class="info-item">
          <label>Passing Score</label>
          <div class="passing-score-display">
            <span class="score-value">{{assessment.passing_score ? assessment.passing_score : 0}}%</span>
            <div class="score-bar">
              <div class="score-fill" [style.width.%]="assessment.passing_score ? assessment.passing_score : 0"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="graph-section">
        <label>Score Graph</label>
        <div class="score-graph-container">
          <img *ngIf="assessment.score_graph && assessment.score_graph !== 'null'" [src]="assessment.score_graph" alt="Score Graph" class="score-graph-preview">
          <div *ngIf="!assessment.score_graph || assessment.score_graph == 'null'" class="no-graph">
            <i class="pi pi-image"></i>
            <span>No graph uploaded</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Dialog -->
<p-dialog [(visible)]="showDialog" [style]="{width: '50vw'}" [header]="dialogHeader" [modal]="true">
  <form [formGroup]="assessmentForm" class="assessment-form">
    <div class="form-field">
      <label for="quizIds">Quiz IDs (comma separated)</label>
      <input id="quizIds" type="text" pInputText formControlName="quizIds" class="w-full" placeholder="e.g., 1,2,3">
    </div>

    <div class="form-field">
      <label for="scoreGraph">Score Graph</label>
      <div class="file-upload-container">
        <div class="file-upload-wrapper">
          <input type="file" id="scoreGraph" accept="image/*" (change)="onFileSelect($event)" class="file-input">
          <label for="scoreGraph" class="file-upload-label">
            <i class="pi pi-upload"></i>
            <span>Choose File</span>
          </label>
          <span class="file-name" *ngIf="selectedFileName">{{selectedFileName}}</span>
        </div>
        <small class="form-help">Upload a graph image (max 1MB)</small>
      </div>
      <div class="image-preview" *ngIf="previewUrl && previewUrl !== 'null'">
        <img [src]="previewUrl | safeURL" alt="Preview" class="preview-image">
        <button class="remove-image" (click)="removeImage()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div class="form-field">
      <label for="formula">Score Formula</label>
      <div class="formula-input-wrapper">
        <input id="formula" type="text" pInputText formControlName="formula" class="w-full" placeholder="e.g., {{incorrect_questions}} * 4 + {{correct_questions}}">
        <div class="formula-help">
          <p>Available variables:</p>
          <ul>
            <li>{{incorrect_questions}} - Number of incorrect questions + Number of omitted questions</li>
            <li>{{correct_questions}} - Correct Percentage (Number of correct questions / Total number of questions) * 100</li>
          </ul>
          <p>Example: {{incorrect_questions}} * 4 + {{correct_questions}}</p>
        </div>
      </div>
    </div>

    <div class="form-field">
      <label for="passingScore">Passing Score</label>
      <div class="passing-score-wrapper">
        <input id="passingScore" type="number" pInputText formControlName="passingScore" class="w-full" min="0" max="100" placeholder="Enter passing score (0-100)">
        <small class="form-help">Enter a value between 0 and 100. This score represents the minimum percentage required to pass the assessment.</small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton label="Save" icon="pi pi-check" class="p-button-primary" (click)="saveAssessment()"></button>
  </ng-template>
</p-dialog>

<!-- Delete Confirmation Dialog -->
<p-dialog [(visible)]="showDeleteDialog" [style]="{width: '30vw'}" header="Confirm Delete" [modal]="true">
  <p>Are you sure you want to delete this self-assessment?</p>
  <ng-template pTemplate="footer">
    <button pButton label="No" icon="pi pi-times" class="p-button-text" (click)="hideDeleteDialog()"></button>
    <button pButton label="Yes" icon="pi pi-check" class="p-button-danger" (click)="confirmDelete()"></button>
  </ng-template>
</p-dialog>
